if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    // LittleNookCo: add the lantern (if the set is chosen) and shipping protection (if ticked) before the knight
    addNookAddons() {
      if (this.closest('quick-add-modal')) return Promise.resolve();
      const checked = Array.from(document.querySelectorAll('.nook-addon__input:checked'));
      if (!checked.length) return Promise.resolve();
      const items = checked.map((el) => ({ id: parseInt(el.dataset.variantId, 10), quantity: 1 }));
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      }).catch((e) => console.error(e));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      }

      config.body = formData;

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      this.addNookAddons()
        .then(() => fetch(`${routes.cart_add_url}`, config))
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// LittleNookCo offer: knight vs knight + lantern, shipping protection inside the selected card,
// and the Add to cart button always shows the total the shopper is about to pay.
(function () {
  function money(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  }

  function setupOffer(offer) {
    if (offer.dataset.ready) return;
    offer.dataset.ready = '1';
    var lantern = offer.querySelector('.nook-offer__lantern');
    var protect = offer.querySelector('.nook-offer__protect');
    var protectInput = protect ? protect.querySelector('input') : null;
    var radios = offer.querySelectorAll('input[name="nook-tier"]');
    var scope = offer.closest('.product__info-container') || offer.closest('section') || document;

    if (protect) {
      protect.classList.add('nook-addons--in-card');
      protect.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    function label() {
      var btn = scope.querySelector('.product-form__submit');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var span = btn.querySelector('span:not(.sold-out-message)') || btn.querySelector('span');
      var checked = offer.querySelector('input[name="nook-tier"]:checked');
      if (!span || !checked) return;
      var total = parseInt(checked.dataset.price || '0', 10);
      if (protectInput && protectInput.checked) total += parseInt(protectInput.dataset.price || '0', 10);
      span.textContent = 'Add to cart · ' + money(total);
    }

    function update() {
      var checked = offer.querySelector('input[name="nook-tier"]:checked') || radios[0];
      if (!checked) return;
      offer.querySelectorAll('.nook-tier').forEach(function (card) {
        card.classList.toggle('is-selected', card.contains(checked));
      });
      if (lantern) lantern.checked = checked.value === 'set';
      var extras = checked.closest('.nook-tier').querySelector('.nook-tier__extras');
      if (protect && extras && protect.parentNode !== extras) extras.appendChild(protect);
      label();
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
    if (protectInput) protectInput.addEventListener('change', label);
    // the theme resets the button text when the color changes, so put the total back afterwards
    scope.addEventListener('change', function (e) {
      if (offer.contains(e.target)) return;
      setTimeout(label, 60);
      setTimeout(label, 400);
    });
    update();
  }

  function init() { document.querySelectorAll('.nook-offer').forEach(setupOffer); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
